module.exports = function anonymous(it
) {
var out='<div class="message js-message"> <span class="text-info lead big-text entity-name">'+(it.domainM.getName())+':</span> <span rel="localize[search.title]">Search in</span> <span class="js-total-number-records strong">'+(it.totalResults)+'</span> <span rel="localize[records]">records</span></div>';return out;
}